import * as s from './HologramDivider.css';

export const HologramDivider = () => (
  <div className={s.hologramDivider}>
    <div className={s.dividerLine} />
    <div className={s.dividerDiamond} />
    <div className={s.dividerLine} />
  </div>
);
